import { isFunction, stopEvent } from '../modules/utils';
import { SimpleDialog } from './dialog';
export class PromiseDialog extends SimpleDialog {
    constructor(html, options) {
        super(html, options);
        this.dialogPromise = null;
        this.successCallback = null;
        this.rejectCallback = null;
        this.rejectOnEscape = true;
        if (typeof (options === null || options === void 0 ? void 0 : options.rejectOnEscape) === 'boolean') {
            this.rejectOnEscape = options.rejectOnEscape;
        }
        this.keyHandler = this.keyHandler.bind(this);
    }
    hide(reason) {
        if (!this.isVisible()) {
            return;
        }
        super.hide();
        if (this.dialog !== null) {
            this.dialog.removeEventListener('keypress', this.keyHandler, false);
        }
        this.reportReject(new Error(reason !== null && reason !== void 0 ? reason : 'ERR_DIALOG_DESTROYED'));
    }
    displayAsync() {
        if (this.dialogPromise !== null) {
            return this.dialogPromise;
        }
        this.dialogPromise = new Promise((resolve, reject) => {
            this.successCallback = resolve;
            this.rejectCallback = reject;
        });
        this.display();
        if (this.dialog !== null) {
            this.dialog.addEventListener('keypress', this.keyHandler, false);
        }
        return this.dialogPromise;
    }
    keyHandler(e) {
        const keycode = e.which ? e.which : e.keyCode;
        if (keycode === 27 && this.rejectOnEscape) {
            stopEvent(e);
            this.hide('ERR_DISMISSED');
            return false;
        }
        return true;
    }
    reportReject(error) {
        if (isFunction(this.rejectCallback)) {
            this.rejectCallback(error);
            this.successCallback = null;
            this.dialogPromise = null;
            this.rejectCallback = null;
        }
    }
    reportRejectOrThrow(error) {
        if (isFunction(this.rejectCallback)) {
            this.reportReject(error);
        }
        else {
            throw error;
        }
    }
}
